import {
  API_ROUTES,
  API_ROUTE_PREFIX,
  IOrderDetailsRequestParams,
  resolveCmpForApiRequest,
} from "@tm/api-utils";
import { LOB } from "@tm/isomorphic-utils";
import { getLobOnServerSide, getPathPartnerOnServerSide } from "@tm/server-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getCancelPolicyDetails = async (
  data: IOrderDetailsRequestParams
): Promise<any> => {
  try {
    const { partner, bookingId, headers, cmp, query, dvid } = data || {};
    const headerCmp = resolveCmpForApiRequest(cmp, query);
    const params = {
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      bookingId,
      authV2: "true",
      ...query,
    };

    const pathPartner = getPathPartnerOnServerSide(partner);
    const urlParams = setURLQueryParams(params);

    const response = await API_HTTP.get(
      `${API_ROUTE_PREFIX}/${pathPartner}/${
        API_ROUTES.TRAVELPROTECT_POST_SALES_CANCEL_INIT
      }${urlParams ? `?${urlParams}` : ""}`,
      {
        headers: { ...headers, cmp: headerCmp, dvid },
      }
    );

    return response;
  } catch (error) {
    console.error("Error", { error });
    throw error;
  }
};
